import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f19f8bba"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("i", { class: "far fa-chevron-down" }, null, -1 /* HOISTED */));
const _hoisted_2 = ["onClick"];
import { ElDropdown, ElDropdownItem, ElDropdownMenu } from "element-plus";
import { useBuiltCampaign } from "src/shared/store/campaign-built/composables";
import { EN_VARIANT } from "src/shared/store/campaign-built/variants";
import { useCampaignVariantsBuiltComponentVariable } from "src/shared/store/component-built/composables";
import { computed, ref, toRef } from "vue";
import { useCampaignVariants } from "src/shared/store/campaign-built/composables/useCampaignVariants";
import Button from "../../ui/Button.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreativeActionCampaignFrontendAssetVariantSelector',
    props: {
        variant: {},
        campaignId: {}
    },
    emits: ["update:variant"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isDropdownVisible = ref(false);
        const onVisibleChange = (visible) => {
            isDropdownVisible.value = visible;
        };
        const { builtCampaign } = useBuiltCampaign(props.campaignId);
        const { variantsVariable } = useCampaignVariantsBuiltComponentVariable(props.campaignId);
        const variantProxy = computed({
            get() {
                return props.variant;
            },
            set(value) {
                emit("update:variant", value);
            },
        });
        const setInitialPreferredVariant = () => {
            if (props.variant === null) {
                emit("update:variant", EN_VARIANT);
            }
        };
        setInitialPreferredVariant();
        const { variants, defaultVariant } = useCampaignVariants(toRef(props, "campaignId"));
        const options = computed(() => {
            const output = [];
            variants.value.forEach((variant) => {
                output.push({
                    value: variant,
                    displayName: variant,
                });
            });
            return output;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(ElDropdown), {
                trigger: "click",
                "hide-on-click": "",
                "popper-class": "list list--drop-down list--drop-down--modern",
                placement: "bottom-end",
                onVisibleChange: onVisibleChange
            }, {
                dropdown: _withCtx(() => [
                    _createVNode(_unref(ElDropdownMenu), null, {
                        default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(variants), (variant) => {
                                return (_openBlock(), _createBlock(_unref(ElDropdownItem), null, {
                                    default: _withCtx(() => [
                                        _createElementVNode("a", {
                                            class: _normalizeClass({
                                                'active-variant': variant === variantProxy.value,
                                            }),
                                            onClick: ($event) => (variantProxy.value = variant)
                                        }, _toDisplayString(variant), 11 /* TEXT, CLASS, PROPS */, _hoisted_2)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1024 /* DYNAMIC_SLOTS */));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                    })
                ]),
                default: _withCtx(() => [
                    _createVNode(Button, {
                        level: 'menu',
                        size: 'extra-small',
                        "is-active": isDropdownVisible.value,
                        onClick: _cache[0] || (_cache[0] = ($event) => (isDropdownVisible.value = true))
                    }, {
                        default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.variant) + " ", 1 /* TEXT */),
                            _hoisted_1
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["is-active"])
                ]),
                _: 1 /* STABLE */
            }));
        };
    }
});
